module.exports = __webpack_public_path__ + "img/48ne.2eb012b3.svg";